import type { MessageResponse } from '@/domain/Api';
import { api } from '@/lib/api';
import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';

export interface ContactFormRequest {
  email: string;
  subject: string;
  description: string;
}

export const submitContactFormMutation = mutationOptions({
  mutationFn: async (values: ContactFormRequest) => {
    return await api
      .post('contact-us', { json: values })
      .json<MessageResponse>();
  },
  onSuccess: () => {
    toast.success('Message sent successfully', {
      description: 'Our support team will respond within 24 hours.',
    });
  },
  onError: (error) => {
    toast.error('Failed to send message', {
      description: error.message || 'Please try again later.',
    });
  },
});
